import axios from 'axios';
import { getToken } from './auth';

const API_PORT = 3000;
const api_hostname = window.location.hostname;
let URL = '';

if (api_hostname === 'localhost' || api_hostname === '0.0.0.0') {
  URL = `http://localhost:${API_PORT}`;
} else if (
  api_hostname.split('.')[0] === '192' &&
  api_hostname.split('.')[1] === '168' &&
  api_hostname.split('.')[2] === '0'
) {
  URL = `http://10.122.161.7:${API_PORT}`;
} else if (api_hostname === '189.108.234.43') {
  URL = `http://189.108.234.43:${API_PORT}`;
} else {
  URL = `https://api.casaflora.com.br`;
}

const Api = axios.create({ baseURL: URL });

Api.interceptors.request.use(async config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default Api;
